/* src/app/app.component.scss */
.view {
  width: 100%;
  height: 100%;
}
.settings {
  z-index: 101;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;
  background: rgba(30, 37, 53, 0.8);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
}
.settings__body {
  width: 800px;
  height: 500px;
  display: flex;
  background: white;
  border-radius: 8px;
  box-shadow: 3px 0 10px rgba(30, 35, 45, 0.3);
  overflow: hidden;
}
.settings__preview {
  width: 45%;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
}
.settings__panel {
  width: 55%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.settings__header {
  padding: 14pt 24px 10pt;
}
.settings__header h2,
.settings__header p {
  width: 100%;
  text-align: left;
}
.settings__content {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 24px 24px;
}
.settings__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px;
}
@media screen and (max-width: 700px) {
  .settings__body {
    flex-direction: column;
    width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }
  .settings__preview,
  .settings__panel {
    width: 100%;
  }
  .settings__preview {
    height: 40%;
  }
  .settings__panel {
    height: 60%;
  }
}
.view__hidden {
  visibility: hidden !important;
}
.overlay {
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  position: fixed;
  z-index: 5;
  background: rgba(255, 255, 255, 0.65);
  box-sizing: border-box;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 250px;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
.overlay .spinner {
  margin-top: 32px;
  animation: spin 4s linear infinite;
}
.overlay h4 {
  width: 100%;
  font-size: 18px;
  text-align: center;
  font-weight: normal;
  color: black;
}
.overlay p {
  width: 80%;
  padding: 0px;
  margin: 0px;
  margin-top: 24px;
  text-align: center;
  color: black;
  color: rgba(0, 0, 0, 0.75);
  line-height: normal;
}
/*# sourceMappingURL=app.component.css.map */
